// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-body {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.cart-item-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-product-name {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: bold;
}

.card-product-price {
  font-size: 1.25rem;
  font-weight: bold;
}

.card-quantity-actions,
.card-selected-quantity {
  font-size: 1.25rem;
  font-weight: bold;
}

/* Styles for increment and decrement buttons */
.card-increment-btn,
.card-decrement-btn {
  background-color: #ced0d4;
  color: #000000;
  border: none;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: bold;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin: 0 0.75rem;
}

/* Styles for the editable quantity input */
.card-selected-quantity {
  min-width: 2rem;
  text-align: center;
  color: #ffffff;
  background-color: #93939300;
  border: none;
  font-size: 1.45rem;
  font-weight: bold;
  width: 3rem;
  border-radius: 15px;
  margin: 0 0.5rem;
}

.card-selected-quantity:focus {
  outline: none;
}

/* Remove from Cart Button */
.remove-cart-btn {
  background-color: #e63819;
  border: none;
  border-radius: 10px;
  overflow: hidden;
  padding: 0 20px;
  height: 2rem;
  font-size: 0.85rem;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  margin: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/CartItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;;EAEE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".card-body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.cart-item-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-product-name {\n  color: #ffffff;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.card-product-price {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.card-quantity-actions,\n.card-selected-quantity {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n/* Styles for increment and decrement buttons */\n.card-increment-btn,\n.card-decrement-btn {\n  background-color: #ced0d4;\n  color: #000000;\n  border: none;\n  border-radius: 50%;\n  font-size: 1rem;\n  font-weight: bold;\n  width: 2rem;\n  height: 2rem;\n  cursor: pointer;\n  margin: 0 0.75rem;\n}\n\n/* Styles for the editable quantity input */\n.card-selected-quantity {\n  min-width: 2rem;\n  text-align: center;\n  color: #ffffff;\n  background-color: #93939300;\n  border: none;\n  font-size: 1.45rem;\n  font-weight: bold;\n  width: 3rem;\n  border-radius: 15px;\n  margin: 0 0.5rem;\n}\n\n.card-selected-quantity:focus {\n  outline: none;\n}\n\n/* Remove from Cart Button */\n.remove-cart-btn {\n  background-color: #e63819;\n  border: none;\n  border-radius: 10px;\n  overflow: hidden;\n  padding: 0 20px;\n  height: 2rem;\n  font-size: 0.85rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: center;\n  margin: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
